module.exports = __webpack_public_path__ + "media/images/export-white-7f0b093f.png";